(function () {
    "use strict";

    // @ngInject
    function ProjectDetailsModalControllerCtor($scope, $injector, $modalInstance, eventId,
                                               AnalyticsService, $stateParams, $sce, moment, $timeout, UiPersistenceService,
                                               CKEDITOR, EventService, ModalService, ModelFactory, CalendarService,
                                               EventsManager, UsersManager, DeviceService) {


        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'ProjectDetailsModalController';

        this.$modalInstance = $modalInstance;
        this.eventId = eventId;

        this.AnalyticsService = AnalyticsService;
        this.EventsManager = EventsManager;
        this.EventService = EventService;
        this.ModelFactory = ModelFactory;
        this.CalendarService = CalendarService;
        this.moment = moment;
        this.$sce = $sce;
        this.event = EventsManager.getEvent(this.eventId);
        this.ModalService = ModalService;
        this.currUser = UsersManager.getCurrUser();
        this.isInViewMode = this.event.isViewOnlyMode();
        this.CKEDITOR = CKEDITOR;
        this.isMobile = DeviceService.checkIfMobileSize();
        this.UiPersistenceService = UiPersistenceService;

        this.currentStep = 1;
        this.dialogWidth = this.isMobile ? $(window).width() : 640;

        this.ctaText = "Update Changes";

        this.setupPrivateNote();

        this.setEditorContents = function setEditorContents(contents) {
            if (this.$editorInstance) {
                this.$editorInstance.setData(contents);
            }
        };

        this.getEditorContents = function getEditorContents() {
            if (this.$editorInstance) {
                return this.$editorInstance.getData();
            }
        };

        this.updateEventInfo = function updateEventInfo() {
            AnalyticsService.track(this, AnalyticsService.analytics_events.send_event_details, {event_id: self.eventId});
            var data = this.getEditorContents();
            EventsManager.updateEventInfoHtml(this.event, data);
        };

        /* CKE */
        this.loadEditor = function loadEditor() {
            var self = this;
            this.editor = this.CKEDITOR.replace('eventDetailsEditorPlaceholder', {
                plugins: 'dialogui,dialog,dialogadvtab,basicstyles,clipboard,button,panelbutton,panel,floatpanel,menu,contextmenu,toolbar,' +
                'enterkey,entities,popup,listblock,richcombo,font,format,horizontalrule,htmlwriter,divarea,wysiwygarea,indent,indentblock,' +
                'indentlist,justify,list,liststyle,pastetext,pastefromword,removeformat,showborders,tab,undo,blockquote,colorbutton',
                skin: 'moono',
                language: 'en',
                title: false,
                startupFocus: false,
                disableNativeSpellChecker: false,
                width: '100%',
                height: '100%',
                toolbar: [
                    {
                        name: 'paragraph',
                        items: ['Format', '-', 'Bold', '-', 'Italic', '-', 'Underline', '-', 'TextColor', '-', 'BGColor', '-', 'JustifyLeft', '-', 'JustifyCenter', '-', 'JustifyRight', '-', 'JustifyBlock', '-', 'BulletedList', '-', 'NumberedList', '-', 'HorizontalRule', '-', 'Blockquote', '-', 'RemoveFormat', '-', 'AddHeaderRegion']
                    }
                ],
                allowedContent: 'p span a b i u s hr h1 h2 h3 h4 ul ol li dd dl blockquote div table tr td [*]{*}(*)',
                baseFloatZIndex: 100000000,
                contentsCss: '/assets/ckeditor.css'
            });
            this.$editorInstance = this.CKEDITOR.instances["eventDetailsEditorPlaceholder"];

            if (this.$editorInstance) {
                this.$editorInstance.on('blur', function () {
                    if (self.$editorInstance.checkDirty()) {
                        self.updateEventInfo();
                    }
                });
                this.editorLoaded = true;
            }

            if (this.$editorInstance) {
                this.$editorInstance.on('focus', function () {
                    self.editEP = true;
                    self.focusFields = true;
                });
            }
        };

        $timeout(function () {
            this.loadEditor();
        }.bind(this), 100);


        var initialized = false;
        this.showEventInfoEditor = false;
        if (this.editorLoaded && this.event.event_info_html_body) {
            this.setEditorContents(this.event.event_info_html_body);
            initialized = true;
            this.showEventInfoEditor = true;
        }

        this.register(this.event, 'success', function success() {
            this.isInViewMode = this.event.isViewOnlyMode();
            this.showKeepTrackMessage = !this.event.hideKeepTrackMessage && this.event.user_visits && this.event.user_visits.visit_counter === 1;
            this.isEventTBD = !this.event.event_date;

            if (!this.editorLoaded) {
                this.loadEditor();
            }
            if (!initialized && !!this.event.event_info_html_body && !this.isInViewMode) {
                this.setEditorContents(this.event.event_info_html_body);
                initialized = true;
                this.showEventInfoEditor = true;
            }

            this.setupPrivateNote();
        });

        // HACK: Needed to gain access to the child form state and helper methods
        // The child form component updates this property with a reference
        // to itself.
        this.eventFormBinding = {};
    }


    Controllers.ProjectDetailsModalController = Class(Controllers.BaseController, {

        constructor: ProjectDetailsModalControllerCtor,

        close: function close() {
            this.$modalInstance.close();
        },

        save: function save() {

        },

        switchToPublish: function switchToPublish() {
            this.currentStep = 2;
        },

        previous: function previous() {

            this.currentStep = 1;
        },

        saveChanges: function saveChanges(changedProperty) {
            if (this.privateNote || (this.event.user_event_notes
                    && this.event.user_event_notes[0] && this.event.user_event_notes[0].text)) {
                if (!this.event.user_event_notes || this.event.user_event_notes.length === 0) {
                    this.event.user_event_notes = [{text: null}];
                }

                this.event.user_event_notes[0].text = this.privateNote;
            }

            this.EventsManager.updateEventDetails(this.event).then(function success(resp) {
                // Update the master collection so we are notified of conflicts when creating events
                var masterCollection = this.ModelFactory.getEventsMasterCollection();
                masterCollection.onCollectionSuccess('event changed');
            }.bind(this));

            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.event_page_details_edit, {
                event_id: this.eventId, edited_property: changedProperty
            });
        },

        setupPrivateNote: function setupPrivateNote() {
            if (this.event.user_event_notes && this.event.user_event_notes[0]) {
                this.privateNote = this.event.user_event_notes[0].text;
            }

            this.showNotesPopover = this.UiPersistenceService.getUiPersistence(this.UiPersistenceService.keys.notesPopover, {show: true}).show;
        },

        dismissNotesPopover: function dismissNotesPopover() {
            this.UiPersistenceService.setUiPersistence(this.UiPersistenceService.keys.notesPopover, {show: false});
            this.showNotesPopover = false;
        },

        isEventBooked: function isEventBooked() {
            var isBooked = false;
            this.event.workspaces.forEach(function (ws) {
                if(ws.workspace_status_type === 'client') {
                    isBooked = true;
                }
            });
            return isBooked;
        },

        onSaveProjectSuccess: function onSaveProjectSuccess(project) {
            this.project = project;
            this.goToProject();
        },

        onCancelProject: function onCancelProject() {
            this.$modalInstance.dismiss();
        },

        goToProject: function goToProject() {
            if(this.project) {
                this.goToState(this.AppStates.root_network_project, {project_id: this.project._id, share: true});
                this.$modalInstance.close(this.project);
            }
        }

    });
}());

